module.exports = __webpack_public_path__ + "static/media/white-desk.5e88987a.jpg";